import * as React from "react";
import { RouteComponentProps } from "react-router-dom";

import { LoadingSpinner } from "@app/shared";
import { AuthenticationService } from ".";

interface SilentRefreshCallbackState {
  foo: string;
}

type SilentRefreshCallbackProps = RouteComponentProps;

class SilentRefreshCallback extends React.Component<SilentRefreshCallbackProps, SilentRefreshCallbackState> {

  constructor(props: SilentRefreshCallbackProps) {
    super(props);
  }

  public async componentDidMount() {
    console.log("silentRefreshCallback invoked, calling signinSilentCallback()");
    try {
      await AuthenticationService.getInstance().signInSilentCallback();
    } catch (e) {
      console.error("signinSilentCallback failed", e);
      throw e;
    }
  }

  public render() {
    return (
      <>
        <div className="pt-3 pl-3">
          <LoadingSpinner />
        </div>
      </>
    );
  }

}

export default SilentRefreshCallback as React.ComponentClass<SilentRefreshCallbackProps>;
